import Home from './routes/Home.svelte';
import Error400 from './routes/error/Error400.svelte';
import Error404 from './routes/error/Error404.svelte';
import Error500 from './routes/error/Error500.svelte';

import CookbookGallery from './routes/CookbookGallery.svelte';
import Cookbook from './routes/Cookbook.svelte';
import CookbookNew from './routes/CookbookNew.svelte';
import CookbookEdit from './routes/CookbookEdit.svelte';

import RecipeGallery from './routes/RecipeGallery.svelte';
import Recipe from './routes/Recipe.svelte';

export const routes = {
    '/': Home,
    '/cookbooks/': CookbookGallery,
    '/cookbooks/new': CookbookNew,
    '/cookbooks/:id/edit': CookbookEdit,
    '/cookbooks/:id': Cookbook,
    '/recipes/': RecipeGallery,
    '/recipes/:id': Recipe,
    '/400': Error400,
    '/404': Error404,
    '/500': Error500,
    '*': Error404
}